import { useQuery } from '@tanstack/react-query';

export interface Announcement {
  id: string;
  date: string;
  title: string;
  body: string;
}

async function fetchAnnouncements(): Promise<Announcement[]> {
  const res = await fetch('/announcements.json');
  if (!res.ok) return [];
  return res.json();
}

export function useAnnouncements(enabled = true) {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: fetchAnnouncements,
    enabled,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
